import { useAppSelector } from "../../store/hooks";
import { useGetQuery } from "../../store/slices/apiSlice";
import { WbGeometry, WbGeometrySection } from "../../store/types";

interface WbGeometryApiProps {
  wellUid?: string | null;
  wellboreUid?: string | null;
  skip?: boolean;
}

export const useWbGeometryAPI = ({
  wellUid,
  wellboreUid,
  skip = false,
}: WbGeometryApiProps) => {
  const geometryEP = useAppSelector((state) => state.endpoints.geometry);
  const wellsEP = useAppSelector((state) => state.endpoints.wells);
  const wellboresEP = useAppSelector((state) => state.endpoints.wellbores);

  const hasBase = Boolean(
    wellsEP && wellUid && wellboresEP && wellboreUid && geometryEP
  );
  const url = hasBase
    ? `${wellsEP}/${wellUid}${wellboresEP}/${wellboreUid}${geometryEP}`
    : "";

  const {
    data: geometry,
    isLoading,
    error,
    refetch,
  } = useGetQuery(url, {
    skip: !hasBase || skip,
    refetchOnMountOrArgChange: true,
  });

  const {
    data: sections,
    isLoading: isSectionsLoading,
    error: sectionsError,
    refetch: refetchSections,
  } = useGetQuery(url ? `${url}/sections` : "", {
    skip: !hasBase || skip,
    refetchOnMountOrArgChange: true,
  });

  return {
    geometryEP,
    geometry: geometry as WbGeometry | undefined,
    isLoading,
    error,
    refetch,
    sections: sections as WbGeometrySection[] | undefined,
    isSectionsLoading,
    sectionsError,
    refetchSections,
  };
};
